import { DismissPayloadType } from "stash/constants/bridgeMessageTypes";

export const dismiss = (type: DismissPayloadType) => {
	return {
		action: 'dismiss',
		payload: {
			type,
		},
	};
};
